import { SCREEN_CATALOG } from "./screenCatalog";

export type ScreenCategoryDefinition = {
  key: string;
  label: string;
  screenKeys: string[];
};

const catalogKeys = new Set<string>(SCREEN_CATALOG.map((s) => s.key));

function keysInCatalog(keys: string[]): string[] {
  return keys.filter((k) => catalogKeys.has(k));
}

export const SCREEN_CATEGORIES: ScreenCategoryDefinition[] = [
  {
    key: "gestao",
    label: "Gestão",
    screenKeys: keysInCatalog([
      "dashboard",
      "lojas",
      "usuarios",
      "entregadores",
      "configuracao_acessos",
      "meu_perfil",
    ]),
  },
  {
    key: "relatorios",
    label: "Relatórios e estatísticas",
    screenKeys: keysInCatalog([
      "estatisticas",
      "relatorios",
      "relatorios_pizzas_por_sabor",
      "relatorios_pizzas_por_tamanho",
      "relatorios_pizzas_brinde",
      "relatorios_pizzas_promocoes",
      "relatorios_pedidos_por_bairro",
      "relatorios_bebidas",
      "relatorios_rodizio_pizzas",
      "relatorios_salao_pizzas",
      "relatorios_salao_bebidas",
      "historicos",
      "historico_pulo_borda",
      "limpeza_pendentes",
    ]),
  },
  {
    key: "metas",
    label: "Metas",
    screenKeys: keysInCatalog(["metas_coletiva", "metas_individual"]),
  },
  {
    key: "producao",
    label: "Produção",
    screenKeys: keysInCatalog([
      "pizzaiolo",
      "pizzaiolo_integracao",
      "producao_porcoes",
      "producao_bebidas",
      "forneiro",
      "bordeiro",
      "roterista",
      "roterista_automatico",
      "cardapio",
      "bordas",
      "tamanhos",
    ]),
  },
  {
    key: "operacao",
    label: "Operação",
    screenKeys: keysInCatalog([
      "filas_integracao",
      "fila_porcoes",
      "fila_bebidas",
      "rodizio",
      "rodizio_urgencia",
      "aguardando_entrega",
      "painel",
      "painel_bordeiro",
      "sequencia_pedidos",
      "inspecao",
      "whatsapp",
      "webhooks_cardapio",
    ]),
  },
  {
    key: "tv_ranking",
    label: "TV / Ranking",
    screenKeys: keysInCatalog([
      "ranking_producao",
      "ranking_montagem",
      "ranking_entregas",
      "ranking_metas_coletiva",
      "ranking_metricas_qualidade",
      "ranking_painel_bordeiro",
      "ranking_retirada",
      "ranking_ficha_diaria",
      "ranking_ficha_setores",
    ]),
  },
  {
    key: "controle_producao",
    label: "Controle de produção",
    screenKeys: keysInCatalog([
      "controle_producao_setores",
      "controle_producao_itens",
      "controle_producao_base_semanal",
      "controle_producao_ficha_diaria",
      "controle_producao_ficha_transferencia",
      "controle_producao_sobras",
      "controle_producao_und_medida",
      "controle_producao_relatorio_consumo",
      "controle_producao_relatorio_tempos",
      "controle_producao_relatorio_equipe",
      "controle_producao_funcionamento",
    ]),
  },
  {
    key: "ferramentas",
    label: "Ferramentas",
    screenKeys: keysInCatalog([
      "atualizar_apk",
      "mensagens_mobile",
      "ferramentas_desenvolvedor",
      "monitoramento_servidor",
      "backups_servidor",
      "crons_servidor",
    ]),
  },
];

export const MANAGEABLE_SCREEN_KEYS = SCREEN_CATEGORIES.flatMap(
  (c) => c.screenKeys
);

export function getScreenLabel(key: string): string {
  return SCREEN_CATALOG.find((s) => s.key === key)?.label ?? key;
}

export const RESTRICTED_SCREEN_KEYS = [
  "atualizar_apk",
  "mensagens_mobile",
  "controle_producao_funcionamento",
  "ferramentas_desenvolvedor",
  "configuracao_acessos",
] as const;
